import C from '@/store/constants'

const DATABASE = 'inspectech'
const DATABASE_VERSION = 1
const SYSTEM_VERSION = 1

const ACCOUNT_TABLE = 'account'
const LOGIN_TABLE = 'login'

function dbInstance(database) {
  return {
    close() {
      database.close()
    },
    index(table, name) {
      const transaction = database.transaction(table, 'readonly')
      const objectStore = transaction.objectStore(table)
      return objectStore.index(name)
    },

    getById(table, id) {
      return new Promise(function (resolve, reject) {
        const transaction = database.transaction(table, 'readonly')
        const objectStore = transaction.objectStore(table)
        const request = objectStore.get(id)

        request.onsuccess = function (event) {
          resolve((event.target).result)
        }

        request.onerror = function (event) {
          reject(event.target)
        }
      })
    },

    list(table, index, value)  {
    return new Promise(function (resolve, reject) {
      const transaction = database.transaction(table, 'readonly')
      const objectStore = transaction.objectStore(table)
      const result = []

      let request
      if (value !== undefined && index !== undefined) {
        const idx = objectStore.index(index)
        request = idx.openCursor(IDBKeyRange.only(value))
      } else {
        request = objectStore.openCursor()
      }

      request.onsuccess = (event) => {
        const cursor = (event.target).result
        if (cursor) {
          result.push(cursor.value)
          cursor.continue()
        } else {
          resolve(result)
        }
      }

      request.onerror = function (event) {
        reject(event.target)
      }
    })
  },

    insert(table, data) {
    return new Promise(function (resolve, reject) {
      const transaction = database.transaction(table, 'readwrite')
      const objectStore = transaction.objectStore(table)
      const request = objectStore.add(data)

      request.onsuccess = function (event) {
        resolve({...data, id: (event.target).result})
      }

      request.onerror = function (event) {
        reject(event.target)
      }
    })
  },

    update(table, id, data) {
    return new Promise(function (resolve, reject) {
      const transaction = database.transaction(table, 'readwrite')
      const objectStore = transaction.objectStore(table)
      const getRequest = objectStore.get(id)

      getRequest.onsuccess = function (event) {
        const updated = {...(event.target).result, ...data, id}
        const updateRequest = objectStore.put(updated)
        updateRequest.onsuccess = function (event) {
          resolve(updated)
        }
        updateRequest.onerror = function (event) {
          reject(event.target)
        }
      }
      getRequest.onerror = function (event) {
        reject(event.target)
      }
    })
  },
}
}

function createSystemSchema(database, oldVersion, newVersion) {
  if(oldVersion < 1) {
    // Account
    const accountStore = database.createObjectStore(ACCOUNT_TABLE, { keyPath: 'id' })
    accountStore.createIndex('tenant', 'tenant', { unique: false })
  }
  if(oldVersion < 2) {
    // Login
    const loginStore = database.createObjectStore(LOGIN_TABLE, { keyPath: 'id' })
  }
}

function createSystemDatabase() {
  return new Promise(function (resolve, reject) {
    const request = indexedDB.open(`${DATABASE}-system`, SYSTEM_VERSION)

    request.onupgradeneeded = function (event) {
      console.log('System database upgrade from ' + event.oldVersion + ' to ' + event.newVersion)
      createSystemSchema(event.target.result, event.oldVersion || 0, event.newVersion)
    }

    request.onsuccess = function (event) {
      resolve(dbInstance(event.target.result)) // db
    }

    request.onerror = function (event) {
      reject(event.target)
    }
  })
}

 function useSystemDatabase() {
  return createSystemDatabase()
}

async function initAccounts(accounts) {
  const db = await useSystemDatabase()
  const promises = []
  for (let i = 0; i < accounts.length; i++) {
    let a = accounts[i]
    promises.push(db.getById(ACCOUNT_TABLE, a.id)
      .then(account => {
        if (!account) {
          db.insert(ACCOUNT_TABLE, a)
        }
      })
    )
  }
  return Promise.all(promises).then(() => accounts)
}

export default {
  namespaced: true,
  state: {},
  actions: {
    getApiKeys({dispatch}) {
      return new Promise(function(resolve, reject) {
        return dispatch('API', C.service.VB_SERVICE, { root: true })
          .then(api => api.get('/api/keys'))
          .then(({data}) => resolve(data))
          .catch(err => reject(err))
      })
    },
    createApiKey({dispatch}, key) {
      return new Promise(function(resolve, reject) {
        return dispatch('API', C.service.VB_SERVICE, { root: true })
          .then(api => api.post('/api/keys', key))
          .then(({data}) => resolve(data))
          .catch(err => reject(err))
      })
    },
    revokeApiKey({dispatch}, {id}) {
      return new Promise(function(resolve, reject) {
        return dispatch('API', C.service.VB_SERVICE, { root: true })
          .then(api => api.delete(`/api/keys/${id}`))
          .then(({data}) => resolve(data))
          .catch(err => reject(err))
      })
    },
    getOfflineAccounts ({ dispatch }) {
      return new Promise(function(resolve, reject) {
        return dispatch('API', C.service.VB_SERVICE, { root: true })
          .then(api => api.get('/offline'))
          .then(({data}) => data)
          .then(({data}) => {
            resolve(initAccounts(data.accounts))
          })
          .catch(err => reject(err))
      })
    },
  }
}
